import { ref, onMounted, computed, readonly } from "vue";
import { useStore } from "vuex";

export function useDistrictsOptions() {
  const store = useStore();
  const loading = ref(false);

  const fetchData = async () => {
    if (store.getters["districts/getOptions"].length > 0) {
      return; // Data already loaded
    }

    loading.value = true;
    try {
      await store.dispatch("districts/getOptions");
    } finally {
      loading.value = false;
    }
  };

  onMounted(fetchData);

  return {
    districts: computed(() => store.getters["districts/getOptions"]),
    loading: readonly(loading),
    refetch: fetchData,
  };
}
